define("settings/components/plan-image", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @shouldShowImage}}
    {{#if (eq @planType "starter")}}
      <img class="o--media tAC--plan__img" src="/assets/images/img--plan--starter.png" />
    {{else if (eq @planType "premium")}}
      <img class="o--media tAC--plan__img" src="/assets/images/img--plan--premium.png" />
    {{else if (eq @planType "plus")}}
      <img class="o--media tAC--plan__img" src="/assets/images/img--plan--plus.png" />
    {{else if (eq @planType "free")}}
      <img class="o--media tAC--plan__img" src="/assets/images/img--plan--free.png" />
    {{else if (eq @planType "brand")}}
      <img class="o--media tAC--plan__img" src="/assets/images/img--plan--brand.png" />
    {{else}}
      <img class="o--media tAC--plan__img" src="/assets/images/img--plan--free.png" />
    {{/if}}
  {{/if}}
  */
  {
    "id": "H+Im7BSG",
    "block": "[[[41,[30,1],[[[41,[28,[37,1],[[30,2],\"starter\"],null],[[[1,\"    \"],[10,\"img\"],[14,0,\"o--media tAC--plan__img\"],[14,\"src\",\"/assets/images/img--plan--starter.png\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[30,2],\"premium\"],null],[[[1,\"    \"],[10,\"img\"],[14,0,\"o--media tAC--plan__img\"],[14,\"src\",\"/assets/images/img--plan--premium.png\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[30,2],\"plus\"],null],[[[1,\"    \"],[10,\"img\"],[14,0,\"o--media tAC--plan__img\"],[14,\"src\",\"/assets/images/img--plan--plus.png\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[30,2],\"free\"],null],[[[1,\"    \"],[10,\"img\"],[14,0,\"o--media tAC--plan__img\"],[14,\"src\",\"/assets/images/img--plan--free.png\"],[12],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,1],[[30,2],\"brand\"],null],[[[1,\"    \"],[10,\"img\"],[14,0,\"o--media tAC--plan__img\"],[14,\"src\",\"/assets/images/img--plan--brand.png\"],[12],[13],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,\"img\"],[14,0,\"o--media tAC--plan__img\"],[14,\"src\",\"/assets/images/img--plan--free.png\"],[12],[13],[1,\"\\n  \"]],[]]]],[]]]],[]]]],[]]]],[]]]],[]],null]],[\"@shouldShowImage\",\"@planType\"],false,[\"if\",\"eq\"]]",
    "moduleName": "settings/components/plan-image.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});